var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.189,
    height: 25.189,
    viewBox: "0 0 25.189 25.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path474",
    d: "M25.189-682.665H0v25.189H25.189Z",
    transform: "translate(0 682.665)",
    fill: "#828282",
    stroke: "#828282",
    strokeWidth: 1.333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g470",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g472",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g478",
    transform: "translate(0.984 8.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path480",
    d: "M21.992,0H7.626a7.626,7.626,0,0,0,0,15.251H19.236",
    fill: "rgba(0,0,0,0)",
    stroke: "#828282",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g482",
    transform: "translate(17.318 1.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path484",
    d: "M-176-340.295l6.494-6.519L-176-353.332",
    transform: "translate(176 353.332)",
    fill: "rgba(0,0,0,0)",
    stroke: "#828282",
    strokeWidth: 2
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.a1166296a0a5fa624ac3e3a43d1ae050.svg";
export { ForwardRef as ReactComponent };